module.exports = __webpack_public_path__ + "img/44s.81b30667.png";